import { Stack } from '@mui/material';
import { styled } from '@mui/material';

export const DashboardCardStyled = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-start',
  padding: theme.spacing(6),
  borderRadius: theme.spacing(6),
  border: `1px solid ${theme.palette.text.fifth}`,
  flexGrow: 1,
  height: '100%',
}));
